import type { ErrorPolicy, FetchPolicy, WatchQueryFetchPolicy } from "@apollo/client/core";

// "no-cache" fetchPolicy is similar as previous "network-only, but does not trigger
// "object is not extensible" error
export const DEFAULT_APOLLO_CLIENT_OPTIONS = {
  watchQuery: {
    fetchPolicy: "no-cache" as WatchQueryFetchPolicy,
    errorPolicy: "ignore" as ErrorPolicy,
  },
  query: {
    fetchPolicy: "no-cache" as FetchPolicy,
    errorPolicy: "all" as ErrorPolicy,
  },
};

export const GRAPHQL_PATH = "/graphql.json";

/**
 * List of status codes that should notify the user with an error message from the server
 */
export const STATUS_CODES_TO_BE_NOTIFIED = [401, 403, 404];

/**
 * https://request-cancellation-test.vercel.app/
 * [
 *  Mozilla cancellation error,
 *  Safari 15,
 *  Safari 14,
 *  Chrome
 * ]
 */
export const CANCELLATION_REQUEST_ERRORS = [
  "NetworkError when attempting to fetch resource.",
  "Load failed",
  "cancelled",
  "Failed to fetch",
  "The operation was aborted.",
];
